import * as THREE from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import Helfer from './Helfer';
import Spieler from './Spieler';
import Terrain from './Terrain';
import HUD from './HUD';
import AudioSpieler from './AudioSpieler';
import SpielFluss from './SpielFluss';
import './styles.scss';

export {
	leinWand,
	leinWandBreite as canvasBreite,
	leinWandHöhe as canvasHöhe,
	szene,
	kamera,
	renderer,
	licht,
	lader
}

Helfer.kompatibilitätsCheck();
// Canvas
const leinWand = document.querySelector('canvas')! as HTMLCanvasElement;
let leinWandBreite = leinWand.clientWidth;
let leinWandHöhe = leinWand.clientHeight;

// Szene
const szene = new THREE.Scene();
// Kamera
const kamera = new THREE.PerspectiveCamera(70, leinWandBreite / leinWandHöhe, 0.1, 100);
// Renderer
const renderer = new THREE.WebGLRenderer( {
 canvas: leinWand
} );
window.addEventListener('resize', () => Helfer.synchronisiereCanvasGrößen(leinWandBreite, leinWandHöhe));
renderer.setSize(leinWandBreite, leinWandHöhe, false);
renderer.setPixelRatio(window.devicePixelRatio);
// Licht
const licht = new THREE.AmbientLight();
// Lader
const lader = new GLTFLoader();
// Spiel
const spieler = new Spieler;
const terrain = new Terrain;
const hud = new HUD;
const audioSpieler = new AudioSpieler;
const spielFluss = new SpielFluss(spieler, terrain, hud, audioSpieler);
// Setze maximale Render Distanz von der Kamera relativ zu den Dimensionen vom Terrain
kamera.far = terrain.breite + terrain.höhe + terrain.breite;
kamera.updateProjectionMatrix();
// Menü und Spiele Info
hud.startKnopf.addEventListener('click', () => {
	if(spielFluss.istErstesSpiel) spielFluss.initializiereSpiel();
	spielFluss.starteSpiel();
});
hud.setzeEreignisHöhrer();